import { Link } from '@solidjs/meta';

export function NoticiaText()
{
	return (<>
		<Link rel='preconnect' href='https://fonts.googleapis.com' />
		<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin='' />
		<Link href='https://fonts.googleapis.com/css2?family=Noticia+Text:ital,wght@0,400;0,700;1,400;1,700&display=swap' rel='stylesheet' />


		
	</>);
}

NoticiaText.fontFamily = '"Noticia Text", serif';
